import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinearProgressBar } from '@hero/atoms';
import { RECOGNITIONS_TAB } from '@hero/constants';
import { DetailItem } from '@hero/molecules';
import { formatPercentage } from '@hero/utils/helper';

import { ChartDescription } from '../ChartDescription';

import * as S from './style';

function ThankYouNotes({ appreciation, style, setActiveTab }) {
  const { t } = useTranslation();
  const appreciationPercentage = formatPercentage(appreciation?.rate * 100, 1);
  const unAppreciationPercentage = formatPercentage(100 - appreciation?.rate * 100, 1);

  return (
    <S.ThankYouNotes style={style}>
      <S.ThankYouNotesTitleWrapper>
        <Typography variant="body1Bold">{t('tyNotes')}</Typography>
        <VerticalDivider $height={16} $margin="0 var(--size-8)" />
        <Button
          variant="link"
          startIcon={<Icon name="preview" />}
          onClick={() => setActiveTab(RECOGNITIONS_TAB.tyNotes)}
        >
          {t('viewList')}
        </Button>
      </S.ThankYouNotesTitleWrapper>
      <S.Card>
        <DetailItem
          bodyStyle={{
            display: 'flex',
            alignItems: 'center'
          }}
          title={`${t('tyNoteRate')}:`}
        >
          <S.BarArea>
            <LinearProgressBar
              backgroundColor="var(--color-warning-weaker)"
              visualParts={[
                {
                  percentage: appreciationPercentage,
                  color: 'var(--color-warning-default)'
                }
              ]}
            />
            <S.Rate>{appreciationPercentage}</S.Rate>
          </S.BarArea>
        </DetailItem>
        <S.Row>
          <ChartDescription
            title={t('notesReceived')}
            total={appreciation?.accepted}
            current={appreciation?.appreciated}
            percent={appreciationPercentage}
            color="var(--color-warning-default)"
          />
          <ChartDescription
            title={t('notesUnreceived')}
            total={appreciation?.accepted}
            current={appreciation?.accepted - appreciation?.appreciated}
            percent={unAppreciationPercentage}
            color="var(--color-warning-weaker)"
          />
        </S.Row>
      </S.Card>
    </S.ThankYouNotes>
  );
}

export { ThankYouNotes };
